$(document).ready(function() {

	$('.people-item a').on('click',function(e) {

		e.preventDefault();
		var href     = $(this).attr('href');
		var team   = $('.people--filters-teams').val();
		var role = $('.people--filters-roles').val();
		var query    = '';

		if ( team || role ) {

			query    = '?';

			if ( team ) {
				query += 'tm=' +team;
			}

			if ( role ) {
				query += '&rl=' +role;
			}

			href = href + query;

		}

		if (history.pushState) {
			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + query;
			window.history.pushState({path:newurl},'',newurl);
		}

		window.location.href = href;

	});

	if ( $('.people--filters-select').length > 0 ) {

		$('.people--filters-select').selectric().on('change',function(e, element, selectric) {

			e.preventDefault();

			var classesArray = [];

			$('.people--filters-select').each(function(){

				var selectClass = $(this).val();

				if (selectClass) {
					classesArray.push(selectClass);
				}

			});

			if (classesArray.length > 0) {

				$people = $('.people-item');

				$people.each(function() {

					var shouldHide = false;
					var person = $(this);

					$.each(classesArray, function(i,val) {

						if ( !person.hasClass(val) ) {
							shouldHide = true;
						}

					});

					if (shouldHide) {
						$(this).addClass('is-hiding');
					} else {
						$(this).removeClass('is-hiding');
					};

				});

			} else {

				$('.people-item').removeClass('is-hiding');

			}

		});

	}

});
